import { createStore } from 'zustand';
import { createGameGeneralSlice } from './slices/gameGeneralSlice.ts';
import { createGameVoteSlice } from './slices/gameVoteSlice.ts';
import { createGameTradeSlice } from './slices/gameTradeSlice.ts';
import { createGameSettingsSlice } from './slices/gameSettingsSlice.ts';
import { createGameModeSlice } from './slices/gameModeSlice.ts';
import { createGameStateSlice } from './slices/gameStateSlice.ts';
import { createGameUserStatesSlice } from './slices/gameUserStatesSlice.ts';
import { createGameDetailsSlice } from './slices/gameDetailsSlice.ts';
import { createGameUserSettingsSlice } from './slices/gameUserSettingsSlice.ts';
import { createGameActionBoxSlice } from './slices/gameActionBoxSlice.ts';
import { createGameReplaySlice } from './slices/gameReplaySlice.ts';
import { createGameEndSlice } from './slices/gameEndSlice.ts';
import { createGameBeginnerHintSlice } from './slices/gameBeginnerHintSlice.ts';
import { createGamePauseSlice } from './slices/gamePauseSlice.ts';
import { createGameActionButtonsSlice } from './slices/gameActionButtonsSlice.ts';
import { createGameCardAnimatorSlice } from './slices/gameCardAnimatorSlice.ts';
import { createGameCardInventorySlice } from './slices/gameCardInventorySlice.ts';
import { createGameMuteSlice } from './slices/gameMuteSlice.ts';
import { createGameClientConfigSlice } from './slices/gameClientConfig.ts';
import { createGameSendEventSlice } from './slices/gameSendEventSlice.ts';
import { createGameAnalyticsSlice } from './slices/gameAnalyticsSlice.ts';
export const createGameStore = ({ gameGeneral, gameState, gameUserStates, gameVote, gameTrade, gameSettings, gameMode, gameDetails, gameUserSettings, gamePause, gameReplay, gameEnd, gameClientConfig, gameSendEvent, gameAnalytics })=>createStore((set, get, api)=>({
            ...createGameGeneralSlice(gameGeneral)(set, get, api),
            ...createGameStateSlice(gameState)(set, get, api),
            ...createGameUserStatesSlice(gameUserStates)(set, get, api),
            ...createGameVoteSlice(gameVote)(set, get, api),
            ...createGameTradeSlice(gameTrade)(set, get, api),
            ...createGameSettingsSlice(gameSettings)(set, get, api),
            ...createGameModeSlice(gameMode)(set, get, api),
            ...createGameDetailsSlice(gameDetails)(set, get, api),
            ...createGameUserSettingsSlice(gameUserSettings)(set, get, api),
            ...createGameActionBoxSlice()(set, get, api),
            ...createGameReplaySlice(gameReplay)(set, get, api),
            ...createGameEndSlice(gameEnd)(set, get, api),
            ...createGameBeginnerHintSlice()(set, get, api),
            ...createGamePauseSlice(gamePause)(set, get, api),
            ...createGameCardAnimatorSlice()(set, get, api),
            ...createGameActionButtonsSlice(set, get, api),
            ...createGameCardInventorySlice()(set, get, api),
            ...createGameMuteSlice()(set, get, api),
            ...createGameClientConfigSlice(gameClientConfig)(set, get, api),
            ...createGameSendEventSlice(gameSendEvent)(set, get, api),
            ...createGameAnalyticsSlice(gameAnalytics)(set, get, api)
        }));
